import script from "./EnLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./EnLayout.vue?vue&type=script&setup=true&lang=js"

import "./EnLayout.vue?vue&type=style&index=0&id=3fac3679&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fac3679"]])

export default __exports__